const palette = {
  gray000: '#FFFFFF',
  gray050: '#FAFAFA',
  gray100: '#F5F5F5',
  gray200: '#EEEEEE',
  gray300: '#E0E0E0',
  gray400: '#BDBDBD',
  gray500: '#9E9E9E',
  gray600: '#757575',
  gray700: '#616161',
  gray800: '#424242',
  gray900: '#212121',

  green1: '#9deecd',
  green2: '#89eac3',
  green3: '#75e7b9',
  green4: '#62e3af',
  green5: '#4ee0a5',
  green6: '#3bdd9b',
  green7: '#35c68b',
  green8: '#2fb07c',
  green9: '#299a6c',
  green10: '#23845d',
  green11: '#1d6e4d',

  orange1: '#f2a98c',
  orange2: '#ef9875',
  orange3: '#ec875e',
  orange4: '#ea7647',
  orange5: '#e76530',
  orange6: '#FF5722',
  orange7: '#ce4b17',
  orange8: '#b74314',
  orange9: '#a03a12',
  orange10: '#89320f',
  orange11: '#722a0d',
};

export default palette;
